<script>
  import { format } from 'svelte-i18n';

  import { Porthole } from '@client/components/porthole';
  import { SectionItem } from '@client/components/section';
  import { Select } from '@client/components/select';

  import { GroupsService } from '@client/services/groups';

  import { isGoogle } from '@client/stores/domain-settings';

  import { generatePastelColors } from '@common/utils/colors';

  let items = [];

  let loaded = false;

  export let defaultGroups;

  export let excludedGroups = [];

  // TODO move to searchable store:
  const searchGoogleGroups = async ({ value = '' }) => {
    const groups = await GroupsService.getGoogleGroups({ bindings: [], query: value });

    const colors = generatePastelColors(groups.length);

    items = groups.map(({ name, uuid, ...rest }) => ({
      ...rest,
      checked: false,
      color: colors.shift(),
      id: uuid,
      label: name,
      name,
      value: uuid
    }));

    loaded = true;
  };

  $: if (isGoogle) {
    searchGoogleGroups({ value: '' });
  }

  $: if (loaded && defaultGroups) {
    excludedGroups = defaultGroups.googlegroupbindings?.map((group) => items.find(({ id }) => id === group.id)) || [];
  }
</script>

{#if $isGoogle}
  <SectionItem
    label={$format('label.GROUP_EXCLUSIONS')}
    tooltip={$format('label.TOOLTIP.GROUP_EXCLUSIONS')}
    description={$format('label.DESCRIPTION.GROUP_EXCLUSIONS')}
    data-testid="google-groups"
  >
    <Select
      bind:items
      bind:value={excludedGroups}
      placeholder={$format('label.EXCLUDED.GROUPS_PLACEHOLDER')}
      class="select-element"
      searchable
      multiple
    >
      <svelte:fragment slot="item" let:item>
        <div class="exclude-groups-item">
          <Porthole details={item} color={item.color} />
          <div class="item-detail">
            <div class="name">
              {$format('label.EXCLUDED.GROUP_ITEM', { values: { name: item.name, count: item.directMembersCount } })}
            </div>
            <div class="email">{$format('label.GOOGLE_GROUP')}</div>
          </div>
        </div>
      </svelte:fragment>
    </Select>
  </SectionItem>
{/if}

<style lang="scss" src="./exclude-groups.scss"></style>
